import React from 'react';
import { TextReplace } from 'src/shared/design-system/Utilities/TextReplace';
import { PostBodyProps } from '../../types';
import { useBody } from './hooks';
import { Comment, Container, Input, InputContainer, MediaButton, PromoCodeText } from './styles';

export const Body: React.FC<PostBodyProps> = (props) => {
  const { buttonProps, comment, promoCode, promoText, isEditMode, inputProps, showButton } = useBody(props);
  const ButtonIcon = buttonProps.icon;

  const promoTextComponent = promoText ? (
    <TextReplace delimiter={promoCode} replaceText={<b key={'promo-code-text'}>{promoCode}</b>} text={promoText} />
  ) : null;
  const commentComponent = (
    <Comment>
      {comment.trim()}
      {comment.trim() && promoText ? `\r\n\r\n` : ''}
      {promoTextComponent ?? ''}
    </Comment>
  );

  return (
    <>
      <Container>
        {isEditMode ? (
          <>
            <InputContainer>
              <Input {...inputProps} />
            </InputContainer>
            {promoTextComponent && <PromoCodeText>{promoTextComponent}</PromoCodeText>}
          </>
        ) : (
          <>
            {commentComponent}
            {showButton && (
              <MediaButton to={buttonProps.to}>
                <ButtonIcon />
                {buttonProps.text}
              </MediaButton>
            )}
          </>
        )}
      </Container>
    </>
  );
};
